import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { trackPageView } from "utils/analytics";

// SPA 換頁時送 page_view（GA 預設只有整頁載入才送）。
// 必須放在 <Router> 裡；初次掛載的網址已由 initAnalytics 送過，trackPageView 會略過不重送。
const PageViewTracker = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    trackPageView({ pathname, search });
  }, [pathname, search]);

  return null;
};

export default PageViewTracker;
